import { render, staticRenderFns } from "./EmployeeSalaryType.vue?vue&type=template&id=58d2e6d9&"
import script from "./EmployeeSalaryType.vue?vue&type=script&lang=js&"
export * from "./EmployeeSalaryType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports